import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'

import type { VariantProps } from '@config/tailwind/cva'
import cn from '@config/tailwind/cn'
import { cva } from '@config/tailwind/cva'

const badgeVariants = cva(
  'ui:focus-visible:border-ring ui:focus-visible:ring-ring/50 ui:aria-invalid:ring-main-red-100/20 ui:aria-invalid:border-main-red-100 group/badge ui:focus-visible:ring-[3px] ui:inline-flex ui:h-5 ui:w-fit ui:shrink-0 ui:items-center ui:justify-center ui:gap-1 ui:overflow-hidden ui:rounded-4xl ui:border ui:border-transparent ui:px-2 ui:py-0.5 ui:text-xs ui:font-medium ui:whitespace-nowrap ui:transition-all ui:has-data-[icon=inline-end]:pr-1.5 ui:has-data-[icon=inline-start]:pl-1.5 ui:[&>svg]:pointer-events-none ui:[&>svg]:size-3!',
  {
    variants: {
      variant: {
        default: 'ui:bg-main-blue-100 ui:text-neutrals-white ui:[a]:hover:bg-main-blue-100/80',
        secondary: 'ui:bg-complementary-purple-100 ui:text-neutrals-white ui:[a]:hover:bg-complementary-purple-100/80',
        destructive:
          'ui:bg-main-red-20 ui:text-main-red-100 ui:[a]:hover:bg-main-red-20/20 ui:focus-visible:ring-main-red-20',
        outline: 'ui:border ui:border-main-blue-75 ui:text-main-blue-100 ui:hover:opacity-90 ui:rounded-full',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

function Badge({
  className,
  variant = 'default',
  render,
  ...props
}: useRender.ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return useRender({
    defaultTagName: 'span',
    props: mergeProps<'span'>(
      {
        className: cn(badgeVariants({ className, variant })),
      },
      props,
    ),
    render,
    state: {
      slot: 'badge',
      variant,
    },
  })
}

export { Badge, badgeVariants }
